import accountRequest from "src/services/request/accountRequest";

export const getNetworks = () =>
  accountRequest({
    method: "get",
    url: "v1/networks",
  });
